import React, { useContext } from "react";
import "../../../../ui-styles/sliders/RightFullSlider.css";
import "../../../../ui-styles/profile/SlideProfileDetails.css";
import { LangCtx } from "../../../../lib/context";
import { dateFormat, getAge } from "../../../../lib/functions";

const PatientProfileSlide = (props) => {
    const { l } = useContext(LangCtx);
    const { data } = props;

    return (
        <div className={props.open ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.profile}</span>
                    </div>
                    <div className="hdrActionGroup">
                        <div className="hdrActItem close" onClick={props.closeSlide}></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="profileContainer">
                    <div className="profileTop">
                        <div className="profileAvtr">
                            {data.profilePic ?
                                <img src={data.profilePic} alt="avatar" />
                                :
                                <div className="roundimg">{data.firstName.charAt(0)}</div>
                            }
                        </div>
                        <h2 className="profileTxtL">{data.firstName ? data.firstName : ''}</h2>
                        <span className="profileTxtS">{data.phone ? data.phone : ''}</span>
                    </div>

                    <div className="profileDetails">
                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_gender}<small className="capitalizeTxt">{data.gender ? data.gender : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_dob}<small>{data.dob ? dateFormat(data.dob) : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_age}<small>{data.dob ?`${getAge(new Date(data.dob))}` : ''}</small></span>
                            </div>
                        </div>

                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.contact_details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_email}<small>{data.email ? data.email : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_phone_no}<small>{data.countryCode? `+${data.countryCode} `:''}{data.phone? data.phone: '--'}</small></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientProfileSlide;